import PropTypes from 'prop-types'
import React from 'react'
import { createContentVisit } from '../createContentVisit'
import { supplierPagePath } from '../routes/path'
import { SupplierResultShape } from './prop_shapes/SupplierResultShape'

const SearchResultLink = ({ supplier, searchId, onClick, children, sponsoredInCategoryId }) => {
  const queryParam = searchId ? `?s=${searchId}` : ''
  const supplierUrl = `${supplierPagePath(supplier.slug)}${queryParam}`

  const handleClick = (event) => {
    onClick && onClick(event, supplierUrl)
    if (!sponsoredInCategoryId) {
      return
    }
    event.preventDefault()
    createContentVisit({
      event_type: 'sponsored_search_result_click',
      href: supplierUrl,
      data: {
        sponsored_supplier_id: Number(supplier.id),
        sponsored_supplier_category_id: sponsoredInCategoryId
      }
    }).then(response => {
      window.location = supplierUrl
    })
  }

  return (
    <a
      className='search-card-link'
      onClick={handleClick}
      href={supplierUrl}
    >
      {children}
    </a>
  )
}

SearchResultLink.propTypes = {
  supplier: SupplierResultShape.isRequired,
  searchId: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node,
  sponsoredInCategoryId: PropTypes.number
}

SearchResultLink.defaultProps = {
  searchId: null,
  onClick: null,
  children: null,
  sponsoredInCategoryId: null
}

export default SearchResultLink
